<template>
  <div>
    <tasks :supporters="supporters" />
    <div class="help-button">
      <help />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Tasks from './components/Tasks.vue';
import Help from '@/components/DispatchHelp.vue';
import moment, { lang } from 'moment';

export default {
  components: {
    Tasks,
    Help
  },
  computed: {
    ...mapGetters(['supporters'])
  },
  async mounted () {
    // this.CLEAR_DATA();
    // let sups = await this.GetSupporters();
    // // let cases = await this.GetAllCases();
    // let params = {  
    //   date: moment().format('YYYY-MM-DD')
    // };
    // let cases = await this.GetTicketByDate(params);
    // if (sups.length > 0 && cases.length > 0) {
    //   this.SET_CASE_TO_SUPPORTERS();
    // }
  },
  methods: {
    ...mapActions([
      'GetSupporters',
      'GetAllCases',
      'GetTicketByDate'
    ]),
    ...mapMutations([
      'CLEAR_DATA',
      'SET_CASE_TO_SUPPORTERS',
      'SET_WAYPOINT_TO_SUPPORTERS'
    ])
  }
};
</script>
<style scoped lang="scss">
.help-button {
  position: fixed;
  bottom: 8px;
  right: 8px;
}
</style>


// WEBPACK FOOTER //
// src/pages/monitor/Index.vue